import { IMedicalPartner } from 'types';
import ApiService from './api-service';
import { IPaginatedListResponse } from './paginated-list-response';
import queryString from 'query-string';
import settings from 'constants/appsettings.json';

export interface IMedicalPartnerSearchParams {
  searchName?: string;
  searchSpecialty?: string;
  searchCity?: string;
  searchState?: string;
  searchCountry?: string;
  searchAffiliation?: string;
  insuranceStatus?: string[];
  hamptonsCoverage?: boolean;
  locations?: string[];
  pageSize?: number;
  pageIncrement?: number;
}

export class MedPartnerService {
  protected apiService: ApiService;
  protected serviceScope: string[];

  constructor(apiService: ApiService) {
    this.apiService = apiService;
    this.serviceScope = settings.serviceScopes.MemberService;
  }

  getMedPartnerCities(): Promise<string[]> {
    return this.apiService.get(this.serviceScope, 'member/v1/MedPartner/cities').then((r) => r?.data);
  }

  getMedPartnerStates(): Promise<string[]> {
    return this.apiService.get(this.serviceScope, 'member/v1/MedPartner/states').then((r) => r?.data);
  }

  getMedPartnerCountries(): Promise<string[]> {
    return this.apiService.get(this.serviceScope, 'member/v1/MedPartner/countries').then((r) => r?.data);
  }

  getMedPartnerLocations(): Promise<string[]> {
    return this.apiService.get(this.serviceScope, 'member/v1/MedPartner/locations').then((r) => r?.data);
  }

  getMedPartnerSpecialties(): Promise<string[]> {
    return this.apiService.get(this.serviceScope, 'member/v1/MedPartner/specialties').then((r) => r?.data);
  }

  getMedPartnerHospitalAffiliations(): Promise<string[]> {
    return this.apiService.get(this.serviceScope, 'member/v1/MedPartner/hospitalAffiliations').then((r) => r?.data);
  }

  getMedPartnerInsuranceStatuses(): Promise<string[]> {
    return this.apiService.get(this.serviceScope, 'member/v1/MedPartner/insuranceStatuses').then((r) => r?.data);
  }

  searchMedPartners(params: IMedicalPartnerSearchParams): Promise<IPaginatedListResponse<IMedicalPartner>> {
    const querystring = queryString.stringify({
      pageSize: params.pageSize || 20,
      pageIncrement: params.pageIncrement || 0,
      ...params
    });
    return this.apiService.get(this.serviceScope, `member/v1/MedPartner/search?${querystring}`).then((r) => r?.data);
  }
}

export default MedPartnerService;
